<template>

    <ul class="notifications">
        <li class="notification" v-if="hasNotifications" v-for="notification in notifications">
            <div class="media">
                <!-- <div class="media-left">
                    <div class="media-object">
                        <img src="https://scontent-ort2-1.xx.fbcdn.net/v/t1.0-1/p100x100/18033408_10102890238880176_6215571418774054455_n.jpg?oh=7078e128043fd0581c36aff7f1bff542&oe=5A8C2642" class="img-circle" alt="Name">
                    </div>
                </div> -->
                <div class="media-body pt-0">
                    <strong class="notification-title">{{ notification.data.headline }}</a></strong>
                    <p class="notification-desc">{{ notification.data.message }}</p>
                    <div class="notification-meta">
                        <small class="timestamp pull-left">{{ notification.created_at | timeAgo }}</small> <small class="pull-right text-primary cursor-pointer" v-on:click="markNotificationAsRead(notification)">Mark as Read</small>
                    </div>
                </div>
            </div>
        </li>
        <li class="notification" v-if="!hasNotifications">
            No new notifications.
        </li>
    </ul>

</template>

<script>

	import { mapActions, mapGetters } from 'vuex';
	import moment from 'moment';

	export default {
		name: 'Notifications',
		data () {
			return {
				msg: 'Welcome to Your Vue.js App'
			}
		},
		mounted() {
        	this.getNotifications();
            setInterval(function () {
                this.getNotifications();
            }.bind(this), 30000);
		},
		computed: {
			...mapGetters([
                'hasNotifications',
                'notifications'
            ]),
        },
        methods: {
            ...mapActions([
				'getNotifications',
				'readNotification'
			]),
			markNotificationAsRead(notification) {
				this.readNotification(notification);
			}
		},
		filters: {
            timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
        },
		
	}
</script>

<style scoped>

	.sidebar {
		height: 100vh;
		background-color: #0055A3;
		color: #fff;
	}

	.sidebar_head {
		height: 80px;
		width: 100%;
		background-color: #004F96;
	}
	

	/* if page is active */
	/* .nav .nav-item {
		border-left: 2px solid #fff;
	} */

	.nav .nav-item a {
		color: #fff;
	}


	.navbar {
		height: 80px;
		background-color: #fff;
	}

	.dropdown-toggle::after {
		vertical-align: 0.1em;
	}

	.nav-user {
		font-size: 18px;
    	color: #0055A3;
		font-weight: 600;
	}


	/* fixed and fluid only on sm and up */
	@media (min-width: 768px) {

		.fixed {
			flex: 0 0 200px;
			min-height: 100vh;
			min-width: 350px
		}

		.col .fluid {
			min-height: 100vh;
		}

		.flex-grow {
			flex:1;
		}

	}


	#navSearch {
		background-color: transparent;
		border: 0px;
		position: relative;
		font-size: 16px;
		font-weight: 600;
	}

	.input-group-addon {
		background-color: transparent;
		border: 0px;
		position: relative;
		font-size: 16px;
		font-weight: 600;
	}

	.user-panel {
		background-color: #F6F7F8;
		padding: 0px;
	}



	/* fixed and fluid only on sm and up */
	@media (min-width: 768px) {

		.fixed {
			flex: 0 0 200px;
			min-height: 100vh;
			min-width: 350px
		}

		.col .fluid {
			min-height: 100vh;
		}

		.flex-grow {
			flex:1;
		}

	}

	/* overrides */

	.profile-details-btn {
		position: absolute;
		right: 20px;
		top: 20px;
		height: 36px;
	}

	.profile-details-btn span {
		font-size: 12px;
		vertical-align: middle;
		display: block;
	}

	.name {
		font-size: 24px;
		font-weight: 600;
	}

	.title {
		font-size: 20px;
		font-weight: 600;
	}

	.city {
		font-size: 18px;
		font-weight: 600;
	}

	.tab-content {
		background-color: #fff;
	}

	.nav-tabs > .nav-item > .nav-link {
		padding: 10px 40px 10px 40px;
	}

	.nav-tabs > .nav-item > a {
		font-size: 16px;
		color: #959CA3;
		font-weight: 600;
	}

	.nav-tabs > .nav-item > a.active {
		color: #0055A3;
	}

	.nav-tabs .nav-link.active {
		border: none;
	}

	.nav-tabs {
		border-bottom:none;
	}

	.nav-tabs .nav-link {
		border: none;
	}

	.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
		border: none;
	}

	.outline {
		border: 1px solid #E9ECEF;
	}

	.btn-outline-primary-custom {
		color: #0055A3;
		background-color: transparent;
		background-image: none;
		border-color: #E7EBEE;
	}

	.fw-300 {
		font-weight: 300;
	}

	.fw-400 {
		font-weight: 300;
	}

	.fw-500 {
		font-weight: 300;
	}

	.fw-600 {
		font-weight: 600;
	}

	.sidebar .nav-item, .sub-menu {
		border-bottom: 1px solid rgba(255, 255, 255, 0.05);
		border-left: none;
		transition: border-left 200ms;
	}

	.sidebar .nav-item.active {
		border-left: 2px solid #fff;;
	}

	.sidebar ul :not(collapsed) .arrow:before,
	.sidebar li :not(collapsed) .arrow:before {
		font-family: FontAwesome;
		content: "\f078";
		display: inline-block;
		vertical-align: middle;
		float: right;
	}

	.sidebar .nav-item:hover {
		border-left: 4px solid #fff;
		transition: border-left 200ms;
	}

	.sub-menu {
		list-style: none;
	}

	.sub-menu li {
		padding-top: 5px;
		padding-bottom: 5px;
	}

	.sub-menu li a {
		color: #fff;
	}

	.sub-menu li a:hover {
		text-decoration: none;
	}

	footer {
		background-color: #EFF1F3;
		text-align: center;
		color: #868e96 !important;
    }
    
    .btn-success.active {
        background-color: #82C843;
		border: 0;
    }

	.cursor-pointer {
		cursor: pointer; 
	}

</style>
